import { render } from "./NewSession.vue?vue&type=template&id=2c66a3aa&scoped=true&ts=true"
import script from "./NewSession.vue?vue&type=script&lang=ts"
export * from "./NewSession.vue?vue&type=script&lang=ts"

import "./NewSession.vue?vue&type=style&index=0&id=2c66a3aa&scoped=true&lang=css"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-ce2d8e187f/2/root/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c66a3aa"]])

export default __exports__